<form [formGroup]="createProjectForm" *ngIf="!inProgress && site; else fallBack" id="createProjectForm">
    <div class="p-fluid cas-flex-row p-formgrid px-5 py-3">
        <div class="p-field p-col-12">
            <label for="project_name">Project Name</label>
            <input type="text" id="project_name" pInputText formControlName="projectName">
        </div>
        <div class="p-field p-col-12" *ngIf="projectGroups.length > 0">
            <label for="project_group">Project Group</label>
            <p-multiSelect [options]="projectGroups" optionLabel="name" formControlName="projectGroups" id="project_group"></p-multiSelect>
        </div>
        <div class="p-field p-col-12">
            <label for="project_description">Description <span class="text-muted">(Optional)</span></label>
            <textarea pInputTextarea id="project_description" [rows]="3" formControlName="projectDescription"></textarea>
        </div>
        <button (click)='addProject()' class="cas-button-action mt-2">Add Project</button>
    </div>
</form>

<ng-template #fallBack>

    <div class="cas-error" *ngIf="!site">No Site Provided</div>

    <div *ngIf="inProgress"><acabim-loading-view></acabim-loading-view></div>

</ng-template>

<p-toast position="center"></p-toast>
